export default __webpack_public_path__ + "static/media/Imagotipo.92e4c40c.svg";